import type { Event } from '@patsnap/tahiti-core/common/event';
import type { DualViewSetting } from '../types';

export const DualViewSettingService = Symbol.for('DualViewSettingService');

export interface DualViewSettingService {
    readonly onStatesChange: Event<DualViewSetting>;

    getModelData(): DualViewSetting;
    updateSetting(target: DualViewSetting): void;
}
